import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import util from '../../util/util'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import _ from 'lodash'

const FilterList = (props) => {
  const history = useHistory()
  var renderSurgeon = () => {
    return props.filters?.surgeon?.map((e, i) => {
      return <Row key={i + 1}>: {util.getObj(props.surgeon, e)?.name}</Row>
    })
  }
  return props.filters && Object.keys(props.filters).length == 1 ? (
    <Row style={{ height: '100%' }} gutter={'10'}>
      <Col style={{ alignSelf: 'center' }} span={4}>
        {'No filters applied.'}
      </Col>
    </Row>
  ) : (
    <>
      <Row align='middle' hidden={!props.filters?.patients} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={8}>
          {history.location.state?.name}
        </Col>
      </Row>
      <Row hidden={!props.filters?.surgeon} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Doctors'}
        </Col>
        <Col span={8}>{renderSurgeon()}</Col>
      </Row>
      {/* <Row hidden={!props.filters?.firstname} gutter={"10"}>
                <Col style={{fontWeight: "bold"}} span={4}>{"First Name"}</Col> 
                <Col span={8}>: {props.filters?.firstname}</Col>
            </Row>
            <Row hidden={!props.filters?.lastname} gutter={"10"}>
                <Col style={{fontWeight: "bold"}} span={4}>{"Lastname Name"}</Col> 
                <Col span={8}>: {props.filters?.lastname}</Col>
            </Row> */}
      <Row
        hidden={!props.filters?.surgeryDate || props.filters?.optype}
        gutter={'10'}
      >
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Surgery Date'}
        </Col>
        <Col span={8}>
          :
          {props.filters?.surgeryDate &&
            props.filters?.surgeryDate.length > 0 &&
            ' ' +
              util.getDateString(props.filters.surgeryDate[0]) +
              ' - ' +
              util.getDateString(props.filters.surgeryDate[1])}
        </Col>
      </Row>
      <Row hidden={!props.filters?.lastdigitsofphone} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Phone (last 4)'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.lastdigitsofphone}</Col>
      </Row>
      <Row hidden={!props.filters?.lastname_plain} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Last Name'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.lastname_plain}</Col>
      </Row>
      <Row hidden={!props.filters?.painlevel} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Pain Level'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.painlevel}</Col>
      </Row>
      <Row hidden={!props.filters?.kneescore} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Hip/Knee Score'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.kneescore?.min +
            ' - ' +
            props.filters?.kneescore?.max}
        </Col>
      </Row>
      <Row hidden={!props.filters?.progress} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Exercise Progress'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.progress?.min + '% - ' + props.filters?.progress?.max}
          %
        </Col>
      </Row>
      <Row hidden={!props.filters?.deviceprogress} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Measurement Progress'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.deviceprogress?.min +
            '% - ' +
            props.filters?.deviceprogress?.max}
          %
        </Col>
      </Row>
      <Row hidden={!props.filters?.surgerytype} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Surgery Type'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.surgerytype
            ? _.upperFirst(props.filters?.surgerytype)
            : ''}
        </Col>
      </Row>
      <Row hidden={!props.filters?.surgerytime} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Surgery Time'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.surgerytime}</Col>
      </Row>
      <Row hidden={!props.filters?.surgeryrange} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Surgery Range'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.surgeryrange +
            `${props.filters?.surgeryrange == 1 ? ' week' : ' weeks'} (${_.upperFirst(props.filters?.optype)})`}
        </Col>
      </Row>
    </>
  )
}

FilterList.propTypes = {
  customer: PropTypes.object,
  filters: PropTypes.object,
  surgeon: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    filters: state.patient.filters,
    surgeon: state.surgeon.surgeons,
  }
}

export default connect(mapStateToProps, null)(FilterList)
